export enum EOrigenDatos {
  Concepto = 0,
  PagaExtra = 1
}
